/**
 * Generates an `Idempotency-Key` for loyalty mutations (accrue / redeem / issue card /
 * upsert tier·rule). The BFF relays the header verbatim to web-loyalty-service so a
 * retried request with the same key does not double-apply the operation.
 */
export function newIdempotencyKey(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID();
  }
  return `idem-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
